const AiPoweredTagline = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="container mx-auto px-4 text-center">
        <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-foreground">
          Feito por você.{" "}
          <span className="text-gradient-ai font-normal">Com ajuda da IA.</span>
        </p>
      </div>
    </section>
  );
};

export default AiPoweredTagline;
